// guest service
import { IBookingRequest, IKeywordSearchRequest, IShortTermBookingRequest } from '../../app/model/guestModel';
import { API_POST_BOOKING } from '../config';
import { userApiClient } from '../HttpClient';



export async function postBooking(
  request: IBookingRequest
): Promise<any> {
  try { 
    const client = await userApiClient;
    const response = await client.post<any>(API_POST_BOOKING, request);
    return response; 
  } catch (error: any) {
    const errorMessage = error?.response?.data?.errorMessage || 'An error occurred';
    throw new Error(errorMessage);
  }
}

export async function postShortTermBooking(request: IShortTermBookingRequest): Promise<any> {
  try {
    const client = await userApiClient;
    const response = await client.post<any>(API_POST_BOOKING, request);
    return response;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.errorMessage || 'An error occurred';
    throw new Error(errorMessage);
  }
}

export async function updateBookingGuestDetails(
  bookingId: string,
  data: { first_name: string; last_name: string; email: string; phone_number: string }
): Promise<any> {
  try {
    const client = await userApiClient;
    const response = await client.patch<any>(`/api/guests/bookings/${bookingId}/update-guest-details/`, data);
    return response;
  } catch (error: any) {
    console.error("Error in updateBookingGuestDetails:", error);
    const errorMessage = error?.response?.data?.error || 'An error occurred while updating guest details';
    throw new Error(errorMessage);
  }
}

export const getBookingDetails = async (bookingId: string): Promise<any> => {
  const client = await userApiClient;
  const response = await client.get(`/api/guests/bookings/${bookingId}/`);
  return response;
};

export async function checkoutBooking(bookingId: string): Promise<any> {
  try {
    const client = await userApiClient;
    const response = await client.post<any>(`/api/guests/bookings/${bookingId}/checkout/`);
    return response;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.error || 'An error occurred during checkout';
    throw new Error(errorMessage);
  }
}

export const checkIn = async (bookingId: string): Promise<any> => {
  const client = await userApiClient;
  const response: any = await client.post(`/api/guests/checkinout/${bookingId}/check-in/`);
  return response.data;
};

export const checkOut = async (bookingId: string): Promise<any> => {
  const client = await userApiClient;
  const response: any = await client.post(`/api/guests/checkinout/${bookingId}/confirm-checkout/`);
  return response.data;
};

export const getGuestBookings = async (): Promise<any> => {
  const client = await userApiClient;
  const response = await client.get(`/api/guests/bookings/`);
  return response;
};